<h3 class="print">
	Phonics Advantage Reading Assessment <br />
	{{ selectedSchool?.name }} &nbsp;/ &nbsp; {{ selectedClassroom?.name
	}}<br />{{ activeStudent?.fname }} {{ activeStudent?.lname }}
</h3>
<div
	class="card bg-primary h-100 w-100 d-print-flex"
	*ngIf="activeStudent"
>
	<div class="card-header" data-html2canvas-ignore>
		<app-component-loader [loading]="LoaderService.loadingStudentTimeGraph"></app-component-loader>
		<div class="float-left">
			<h5>{{activePhase.title}}</h5>
		</div>
	</div>

	<div class="d-print-flex" id="timeGraphHolder"></div>
</div>
